import { useCallback, useState } from 'react';
import client from '../api/client';

export function useChat(token, surveyId) {
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const sendMessage = useCallback(
    async (text, { silent = false } = {}) => {
      const trimmed = text.trim();
      if (!trimmed || !token) return null;

      if (!silent) {
        setMessages((prev) => [...prev, { id: `u-${Date.now()}`, role: 'user', message: trimmed }]);
      }
      setIsLoading(true);

      try {
        const response = await client.post('/chatbot/message', {
          token,
          survey_id: surveyId ? Number(surveyId) : undefined,
          message: trimmed,
        });
        const botMessage = response.data?.data?.message || 'No response.';

        setMessages((prev) => [...prev, { id: `b-${Date.now()}`, role: 'bot', message: botMessage }]);
        return botMessage;
      } finally {
        setIsLoading(false);
      }
    },
    [token, surveyId]
  );

  return { messages, sendMessage, isLoading, setMessages };
}
